/* global navigator */
/* global alert */
import React from 'react';
import { browserHistory } from 'react-router';

import LocationHelpers, { setApiKey } from '@arreeba/ristoranti-frontend-lib/lib/helpers/location';
import {
  lastOrdersSelector,
} from '@arreeba/ristoranti-frontend-lib/lib/selectors/user';

import { connect } from '../../util';
import Url from '../../lib/url';
import BoxedItem from '../../components/boxed-item';
import BackButton from '../../components/back-button';
import ButtonsContainer from '../../components/buttonsContainer';
import { GOOGLE_API_KEY } from '../../lib/env';

class OrderDelivery extends React.Component {
  constructor(props) {
    super(props);
    this.checkUserLocation = this.checkUserLocation.bind(this);
    this.setDeliveryAddress = this.setDeliveryAddress.bind(this);
    this.onLocationError = this.onLocationError.bind(this);
  }

  onLocationError(e) {
    console.warn(e);
    this.props.actions.ux.setIsGettingUserLocation(false);
    this.props.actions.ux.setMessage({
      title: 'Attenzione',
      text: 'Impossibile ottenere la posizione corrente',
    });
  }

  setDeliveryAddress(data) {
    const { lat, lng } = data.location;
    const description = LocationHelpers.formatAddressDescription(data.address);
    const location = LocationHelpers.deliveryAddressFactory(
      description,
      lat,
      lng,
      data.address,
    );
    this.props.services.order.deliveryAddressCheck(
      this.props.app.id,
      location,
      this.props.actions.order,
    );
    this.props.actions.order.setDeliveryAddress(location);

    // reload order if we're using an address from previuos order
    if (data.id) {
      this.props.actions.order.reloadOrder(data);
    }
  }

  checkUserLocation() {
    this.props.actions.ux.setIsGettingUserLocation(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setApiKey(GOOGLE_API_KEY);
        LocationHelpers.addressFromCoordinates(
            position.coords.latitude,
            position.coords.longitude,
          )
          .then((o) => {
            const data = {
              location: o.data.address.location.geometry.location,
              address: o.data.address.components,
            };
            this.props.actions.ux.setIsGettingUserLocation(false);
            this.setDeliveryAddress(data);
          })
          .catch(this.onLocationError);
      },
      this.onLocationError,
    );
  }

  render() {
    const appId = this.props.url.appId;
    return (
      <main>
        <div className="orderDeliveryContainer">
          <header>
            <h4 className="viewTitle">Consegna a domicilio</h4>
            <p>Seleziona l'indirizzo di consegna</p>
          </header>
          <div>
            <BoxedItem
              title="Posizione corrente"
              subtitle="Consegna qui!"
              icon="bi_location-pin"
              isLoading={this.props.ux.isGettingCurrenUserPosition}
              onClick={this.checkUserLocation}
            />
            <BoxedItem
              title="Inserisci nuovo indirizzo"
              icon="bi_location-pin-plus"
              onClick={() => browserHistory.push(Url.orderDeliveryAddress(appId))}
            />
          </div>
          {this.props.lastOrders.length > 0 &&
            <div className="lastOrders">
              {this.props.lastOrders.map(order => (
                <BoxedItem
                  key={order.id}
                  title={`${order.address.route}, ${order.address.street_number}, ${order.address.city}`}
                  subtitle={order.address.citofono}
                  icon="bi_location-pin"
                  onClick={() => this.setDeliveryAddress(order)}
                />
              ))}
            </div>
          }
          <ButtonsContainer>
            <BackButton />
          </ButtonsContainer>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state, props) => ({
  ...state,
  lastOrders: lastOrdersSelector(state, props),
});
export default connect(OrderDelivery, { mapStateToProps });



// WEBPACK FOOTER //
// ./src/containers/order/order-delivery.js